import { RawMaterial } from '@interfaces/raw-material';
import { getCall } from '@services/rest-service';

// Retrieves all the raw materials from cosmos
export const getRawMaterials = (): Promise<RawMaterial[]> => {
  return getCall<RawMaterial[]>('raw-materials');
};